export default {
  name: 'Cache',
  install: function (Vue, options) {
    function toString(value) {
      if (typeof value === 'object') {
        return JSON.stringify(value)
      }
      return value
    }

    function toObject(datastr) {
      if (typeof datastr === 'string' && datastr.indexOf('{') < 0) {
        return datastr
      }
      try {
        return JSON.parse(datastr)
      } catch (e) {
        return null
      }
    }
    // 全局缓存设置 默认 session storage
    Vue.setCache = function (key, value, type) {
      if (type === 'local') {
        window.localStorage.setItem(key, toString(value))
      } else {
        window.sessionStorage.setItem(key, toString(value))
      }
    }
    // 全局缓存删除 默认 session storage
    Vue.removeCache = function (key, value, type) {
      if (type === 'local') {
        window.localStorage.removeItem(key)
      } else {
        window.sessionStorage.removeItem(key)
      }
    }
    // 全局缓存获取 默认 session storage
    Vue.getCache = function (key, type) {
      if (type === 'local') {
        return toObject(window.localStorage.getItem(key))
      } else {
        return toObject(window.sessionStorage.getItem(key))
      }
    }
    Vue.getCacheString = function (key, type) {
      if (type === 'local') {
        return toString(window.localStorage.getItem(key))
      } else {
        return toString(window.sessionStorage.getItem(key))
      }
    }

    // 全局权限缓存
    function getMenuActions(_arr) {
      let _actionMap = {}
      if (_arr && _arr.length > 0) {
        _arr.forEach(_a => {
          if (_a.submenus) {
            Object.assign(_actionMap, getMenuActions(_a.submenus))
          } else if (_a.actions) {
            _actionMap[_a.id] = getMenuActions(_a.actions)
            _actionMap[_a.id]['name'] = _a.name
          } else if (_a.code) {
            _actionMap[_a.code] = {
              uri: _a.uri,
              name: _a.name,
              icon: _a.icon
            }
          }
        })
      }
      return _actionMap
    }
    // 缓存全部菜单
    function getMenusMap(_arr, menusMap) {
      if (_arr && _arr.length > 0) {
        _arr.forEach(_a => {
          menusMap[_a.id] = {
            id: _a.id,
            uri: _a.uri,
            name: _a.name,
            icon: _a.icon,
            parentId: _a.parentId
          }
          if (_a.submenus && _a.submenus.length > 0) {
            getMenusMap(_a.submenus, menusMap)
          }
        })
      }
    }
    Vue.setPermission = function (_arr) {
      window.sessionStorage.setItem('Permission', toString(getMenuActions(_arr)))
    }
    Vue.getPermission = function (_actionname, _activeMenu) {
      let _menus = toObject(window.sessionStorage.getItem('Permission'))
      if (_menus) {
        let _actions = _menus[Vue.getActiveMenu()]
        if (_activeMenu === 'home') {
          _actions = _menus['home']
        }
        // console.info('_actions:', _actions)
        if (_actions && _actionname) {
          return _actions[_actionname]
        }
        return _actions
      }
      return null
    }
    Vue.setMenuMap = function (_arr) {
      let menusMap = {}
      toString(getMenusMap(_arr, menusMap))
      window.sessionStorage.setItem('MenusArray', toString(menusMap))
    }
    Vue.getParentPermission = function (_parentId) {
      let _menus = toObject(window.sessionStorage.getItem('MenusArray'))
      if (_menus) {
        let _parent = _menus[_parentId]
        if (_parent) {
          return _parent
        }
        return null
      }
    }
    Vue.setActiveMenu = function (_id) {
      window.sessionStorage.setItem('ActiveMenu', toString(_id))
      // console.info('ActiveMenu:', _id)
    }
    Vue.getActiveMenu = function () {
      return toString(window.sessionStorage.getItem('ActiveMenu'))
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/cache.js